export type EventTypeEnum =
  | 'scheduler'
  | 'start'
  | 'end_success'
  | 'end_failure'
  | 'notification'
  | 'change_job';

export interface Alocacao {
  celebrationJobLocationId: string;
  localNome: string;
  memberId: string;
  membroNomeColete: string;
  membroNome: string;
  telefoneCelular: string;
  statusAtualEnum: EventTypeEnum;
}

export interface AcaoOperador {
  label: string;
  eventTypeEnum: EventTypeEnum;
  icone: string;
  allowedFrom: EventTypeEnum[];
  observacaoObrigatoria: boolean;
}

export interface RegistroFila {
  memberId: string;
  celebrationJobLocationId: string;
  localNome: string;
  membroNome: string;
  acao: string;
  eventTypeEnum: EventTypeEnum;
  observacao: string;
  dataHora: string;
}

export interface ConfirmacaoAcaoDialogData {
  membro: Alocacao;
  acao: AcaoOperador;
}

export interface ConfirmacaoAcaoDialogResult {
  observacao: string;
}

/** Valores aceitos pelo backend em POST /bpv/events/ocorrencias/sync. */
export type BackendEventEnum =
  | 'AGENDADO'
  | 'INICIO_TURNO'
  | 'TROCA_LOCAL'
  | 'FIM_TURNO_SUCESSO'
  | 'FIM_TURNO_FALHA';
// TODO(backend): adicionar o enum de Ocorrência/Disciplina (ex.: 'OCORRENCIA')
// e mapear em EVENT_ENUM_BACKEND.notification quando o endpoint suportar.

/** Corpo de cada item enviado ao endpoint de sincronização. */
export interface OcorrenciaSyncRequest {
  memberId: string;
  celebrationJobLocationId: string;
  eventTypeEnum: BackendEventEnum;
  registroDataHora: string;
  observacao?: string;
}

/**
 * Mapeia o enum interno do front para o enum do backend.
 * `notification` (Ocorrência/Disciplina) não tem correspondente no backend.
 */
const EVENT_ENUM_BACKEND: Record<EventTypeEnum, BackendEventEnum | null> = {
  scheduler: 'AGENDADO',
  start: 'INICIO_TURNO',
  change_job: 'TROCA_LOCAL',
  end_success: 'FIM_TURNO_SUCESSO',
  end_failure: 'FIM_TURNO_FALHA',
  notification: null, // TODO(backend): trocar por 'OCORRENCIA' quando o enum existir
};

/** true se a ação pode ser enviada ao backend (tem enum correspondente). */
export function isSincronizavel(eventTypeEnum: EventTypeEnum): boolean {
  return EVENT_ENUM_BACKEND[eventTypeEnum] !== null;
}

/**
 * Converte um RegistroFila (modelo local/rico) no corpo aceito pelo backend.
 * Retorna null para tipos sem correspondente (ex.: notification).
 */
export function registroParaRequest(r: RegistroFila): OcorrenciaSyncRequest | null {
  const eventTypeEnum = EVENT_ENUM_BACKEND[r.eventTypeEnum];
  if (!eventTypeEnum) return null;
  return {
    memberId: r.memberId,
    celebrationJobLocationId: r.celebrationJobLocationId,
    eventTypeEnum,
    registroDataHora: r.dataHora,
    observacao: r.observacao || undefined,
  };
}
